import { ErrorToolTip, TooltipDirection } from '../general/newErrorToolTip';
import { CurrentPage } from '../pages/currentPage';
import { Localization } from '../localization/localization';
import {
    CheckEmailAvailableResponse
} from '@scorewarrior/rubens_web_lib/lib/hub-api/protocol/check-email-available-req';
import { HubApiError } from '../domains/valueObject/SwitchUserProgressResponses';
import { getHubApi } from '../general/modules/accountServiceApi/getAccountServiceApi';

function actOnErrorResponse(emailField: JQuery, tooltip: ErrorToolTip, errorMessage: string) {
    emailField.parent().addClass('error');
    tooltip.showTooltipElement(
        emailField.parent(),
        TooltipDirection.UP,
        errorMessage
    );
}

function actOnException(emailField: JQuery, tooltip: ErrorToolTip, exception: Error) {
    tooltip.showTooltipElement(
        emailField.parent(),
        TooltipDirection.UP,
        Localization._n('common_error')
    );
    console.error(exception);
    window.Sentry.captureException(exception);
}

export async function checkEmailAvailable(
    emailField: JQuery,
    tooltip: ErrorToolTip
): Promise<boolean> {
    const email: string = (emailField.val() as string).trim();

    CurrentPage.setLoadingState();

    const hubApi = getHubApi();

    return await hubApi.checkEmailAvailable(window.app.deviceIdentifier, email)
        .then((response: CheckEmailAvailableResponse | HubApiError) => {
            CurrentPage.disableLoadingState();
            if ('error' in response) {
                actOnErrorResponse(emailField, tooltip, response.error.message);
                return false;
            }

            tooltip.hide();
            return true;
        })
        .catch((error) => {
            CurrentPage.disableLoadingState();
            actOnException(emailField, tooltip, error);
            return false;
        });
}
